import { updateMomentsSetting } from './update'

export const momentsSetting = {
  update: updateMomentsSetting,
}
